import { Typography } from '@repo/ui/Typography';
import type { ElementType, ReactNode } from 'react';
import type { StructuredContent } from './types';
type ComponentProps = Record<string, Record<string, unknown>>;
export function createStructuredContentRenderer(components: Record<string, ElementType>, overrides?: Record<string, ElementType>) {
  function renderDoc(doc: StructuredContent | StructuredContent[], useLearnContentOverrides?: boolean, componentProps?: ComponentProps): ReactNode {
    if (typeof doc === 'string') {
      return <Typography as="span">{doc}</Typography>;
    }
    return <>
        {[doc].flat().map((child, idx) => {
        if (typeof child === 'string') {
          // biome-ignore format: lint suppression requires key on same line as return
          // biome-ignore lint/suspicious/noArrayIndexKey: structured content nodes have no stable id
          return <Typography key={`sc-doc-text-${idx}`} as="span">
              {child}
            </Typography>;
        }
        if (!child) return null;
        let Component = components[child.type];
        if (useLearnContentOverrides && overrides && child.type in overrides) {
          Component = overrides[child.type];
        }
        if (!Component) return null;
        const extraProps = componentProps?.[child.type];
        const mergedProps = extraProps ? {
          ...(child.props ?? {}),
          ...extraProps
        } : child.props ?? {};

        // biome-ignore format: lint suppression requires key on same line as return
        // biome-ignore lint/suspicious/noArrayIndexKey: structured content nodes have no stable id
        return <Component key={`sc-doc-${idx}`} type={child.type} version={child.version} props={mergedProps} />;
      })}
      </>;
  }
  function StructuredContentRenderer({
    doc,
    useLearnContentOverrides
  }: {
    doc: StructuredContent;
    useLearnContentOverrides?: boolean;
  }) {
    return renderDoc(doc, useLearnContentOverrides);
  }
  return {
    StructuredContentRenderer,
    renderDoc
  };
}